import axios from 'axios'

function getHospitalInfo () {
  // let key = localStorage.getItem('sessionKey')
  // const headers = {
  //   Authorization: `Bearer ${key}`
  // }
  // return axios.get(`${process.env.VUE_APP_Q_OPD_API}/hospital-config/info`, {
  //   headers
  // })
  //   .then((res) => res.data)
  //   .catch((err) => {
  //     console.log(err)
  //     return Promise.reject(err.response)
  //   })
  return Promise.resolve({
    name: 'โรงพยาบาลพระมงกุฎเกล้า'
  })
}

export {
  getHospitalInfo
}
